(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["selling-plans-widget"] && !Shopify.designMode) return;
  try {
    class SubscriptionPlansWidget extends HTMLElement {
    connectedCallback() {
      this.purchaseOptionRadios = Array.from(
        this.querySelectorAll('input[name^="SubscriptionWidget-PurchaseOption-"]')
      );
      this.planSelect = this.querySelector('select[data-selling-plan-select]');
      this.planRadios = Array.from(this.querySelectorAll('input[data-selling-plan-option]'));
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
      this.subscriptionDetails = Array.from(this.querySelectorAll('[data-subscription-details]'));
      this.subscriptionPrice = this.querySelector('[data-subscription-price]');

      const jsonEl = this.querySelector('script[data-linked-purchase-json]');
      if (jsonEl?.textContent) {
        try {
          this.linkedPurchaseConfig = JSON.parse(jsonEl.textContent);
        } catch {
          this.linkedPurchaseConfig = null;
        }
      } else {
        this.linkedPurchaseConfig = null;
      }

      this.onChange = this.onChange.bind(this);
      this.onVariantUpdate = this.onVariantUpdate.bind(this);
      this.boundDeferredApply = () => {
        setTimeout(() => {
          if (!this.isConnected) return;
          this.applyPurchaseSelectionToForm();
        }, 0);
      };

      this.addEventListener('change', this.onChange);

      const target = this.closest('.shopify-section, dialog') || document;
      target.addEventListener('variant:update', this.boundDeferredApply);
      target.addEventListener('variant:update', this.onVariantUpdate);

      this.#initPageVariantId();

      this.applySellingPlanFromUrl();
      this.syncFromDom();
      this.updateUrlFromState();

      setTimeout(() => this.applyPurchaseSelectionToForm(), 0);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      const target = this.closest('.shopify-section, dialog') || document;
      target.removeEventListener('variant:update', this.boundDeferredApply);
      target.removeEventListener('variant:update', this.onVariantUpdate);
    }

    #initPageVariantId() {
      const url = new URL(window.location.href);
      const fromUrl = url.searchParams.get('variant');
      if (fromUrl) {
        this._pageVariantId = String(fromUrl);
        return;
      }
      const formEl = this.closest('.shopify-section, dialog')?.querySelector('product-form-component');
      const variantInput = formEl?.querySelector('input[ref="variantId"]');
      if (variantInput instanceof HTMLInputElement && variantInput.value) {
        this._pageVariantId = String(variantInput.value);
      }
    }

    getPageVariantId() {
      const url = new URL(window.location.href);
      const fromUrl = url.searchParams.get('variant');
      if (fromUrl) return String(fromUrl);
      if (this._pageVariantId) return String(this._pageVariantId);
      const formEl = this.closest('.shopify-section, dialog')?.querySelector('product-form-component');
      const variantInput = formEl?.querySelector('input[ref="variantId"]');
      if (variantInput instanceof HTMLInputElement && variantInput.value) {
        return String(variantInput.value);
      }
      return '';
    }

    applyPurchaseSelectionToForm() {
      if (!this.linkedPurchaseConfig?.variants?.length) return;

      const formEl = this.closest('.shopify-section, dialog')?.querySelector('product-form-component');
      if (!formEl) return;
      const variantInput = formEl.querySelector('input[ref="variantId"]');
      if (!(variantInput instanceof HTMLInputElement)) return;

      const pageVariantId = this.getPageVariantId();
      if (!pageVariantId) return;

      const entry = this.linkedPurchaseConfig.variants.find(
        (row) => String(row.pageVariantId) === pageVariantId
      );
      const purchaseOption = this.getSelectedPurchaseOption();
      let targetId = pageVariantId;
      if (entry) {
        targetId =
          purchaseOption === 'subscription'
            ? String(entry.subscriptionVariantId)
            : String(entry.otpVariantId);
      }
      variantInput.value = targetId;
    }

    getSelectedPurchaseOption() {
      const selected = this.purchaseOptionRadios.find((radio) => radio.checked);
      return selected?.value || 'subscription';
    }

    getSelectedSellingPlanId() {
      if (this.planSelect instanceof HTMLSelectElement) return this.planSelect.value || '';
      const checked = this.planRadios?.find((r) => r.checked);
      return checked?.value ?? '';
    }

    setPurchaseOption(value) {
      for (const radio of this.purchaseOptionRadios) {
        radio.checked = radio.value === value;
      }
    }

    applySellingPlanFromUrl() {
      const url = new URL(window.location.href);
      const sellingPlanId = url.searchParams.get('selling_plan');
      if (!sellingPlanId) return;

      if (this.planSelect instanceof HTMLSelectElement) {
        const hasOption = Array.from(this.planSelect.options).some((opt) => opt.value === sellingPlanId);
        if (!hasOption) return;
        this.planSelect.value = sellingPlanId;
      } else if (this.planRadios?.length) {
        const radio = this.planRadios.find((r) => r.value === sellingPlanId);
        if (!radio) return;
        radio.checked = true;
      } else return;

      this.setPurchaseOption('subscription');
    }

    syncFromDom() {
      const purchaseOption = this.getSelectedPurchaseOption();
      const isSubscription = purchaseOption === 'subscription';

      for (const el of this.subscriptionDetails) {
        el.hidden = !isSubscription;
      }

      if (!(this.sellingPlanInput instanceof HTMLInputElement)) return;

      if (!isSubscription) {
        this.sellingPlanInput.value = '';
      } else {
        const planId = this.getSelectedSellingPlanId();
        this.sellingPlanInput.value = planId || '';
      }

      if (this.subscriptionPrice) {
        let priceText = '';
        if (this.planSelect instanceof HTMLSelectElement) {
          const option = this.planSelect.selectedOptions?.[0];
          priceText = option?.dataset?.sellingPlanPriceText ?? '';
        } else {
          const checked = this.planRadios?.find((r) => r.checked);
          priceText = checked?.dataset?.sellingPlanPriceText ?? '';
        }
        if (priceText) this.subscriptionPrice.textContent = priceText;
      }

      this.applyPurchaseSelectionToForm();
    }

    updateUrlFromState() {
      const url = new URL(window.location.href);

      const purchaseOption = this.getSelectedPurchaseOption();
      const sellingPlanId = purchaseOption === 'subscription' ? this.getSelectedSellingPlanId() : '';

      if (sellingPlanId) {
        url.searchParams.set('selling_plan', sellingPlanId);
      } else {
        url.searchParams.delete('selling_plan');
      }

      history.replaceState({}, '', url.toString());
    }

    onChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (
        target.matches('input[name^="SubscriptionWidget-PurchaseOption-"]') ||
        target.matches('select[data-selling-plan-select]') ||
        target.matches('input[data-selling-plan-option]')
      ) {
        this.syncFromDom();
        this.updateUrlFromState();
      }
    }

    onVariantUpdate(event) {
      const detail = event?.detail;
      if (detail?.resource?.id) {
        this._pageVariantId = String(detail.resource.id);
      }
      if (!detail?.data) return;
      if (detail.data.productId && String(detail.data.productId) !== String(this.dataset.productId)) return;

      const doc = detail.data.html;
      if (!(doc instanceof Document)) return;

      const selector = `subscription-plans-widget[data-block-id="${this.dataset.blockId}"]`;
      const next = doc.querySelector(selector);
      if (!(next instanceof HTMLElement)) return;

      this.replaceWith(next);
    }
  }

  if (!customElements.get('subscription-plans-widget')) {
    customElements.define('subscription-plans-widget', SubscriptionPlansWidget);
  }
  } catch(e) { console.error(e); }
})();

})();
